<template>
  <Panel class="intro-y" :title="$t('text.customerInfoPassportImages')">
    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-12 lg:col-span-6">
        <div>
          <CustomerImageUpload
            :label="$t('label.passportFrontImage')"
            :value="customer.passportImageFront || ''"
            image-type="passport_front"
            :customer-id="customer.id"
            :disabled="disabled"
          />
        </div>
      </div>
      <div class="col-span-12 lg:col-span-6">
        <div>
          <CustomerImageUpload
            :label="$t('label.passportBackImage')"
            :value="customer.passportImageBack || ''"
            image-type="passport_back"
            :customer-id="customer.id"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/ui/Panel';
import CustomerImageUpload from '@/components/customer/CustomerImageUpload';

export default {
  props: {
    customer: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Panel,
    CustomerImageUpload,
  },
};
</script>
